import { BaseApi } from '@/api/baseApi';
import { TAccount, TUser, TUserUpdate } from '@/types/users';

export type TRemoveUserRequest = {
    id: number
    disabled: 0 | 1
}

export type TLoginRequest = {
    login: string,
    password: string,
}

export class User extends BaseApi {
    public async getUsers(): Promise<TUser[]> {
        return await this.get<TUser[]>('/list');
    }

    public async getUserById(id: string): Promise<TUser> {
        return this.get<TUser, string>(`/byId/${id}`);
    }

    public async removeUser(data: TRemoveUserRequest): Promise<void> {
        await this.delete<void, TRemoveUserRequest>('', data);
    }

    public async updateUser(data: TUser): Promise<TUser | undefined> {
        return await this.patch<TUser, TUser>('', data);
    }

    public async createUser(data: TUserUpdate): Promise<void> {
        await this.put<TUser, TUserUpdate>('', data);
    }

    public async login(data: TLoginRequest): Promise<TAccount> {
        return await this.post('/auth', data);
    }

    public async checkAuth(): Promise<TAccount> {
        return await this.get('');
    }
}
